import { id } from "../../function/id";
import * as A from "../array";
import * as Setoid from "../setoid";
import * as E from "fp-ts/Either";
import * as RNEA from "fp-ts/ReadonlyNonEmptyArray";
export * from "./optics";
export const right = E.right;
export const left = E.left;
export const leftV = (e) => left(RNEA.of(e));
export const prRight = (e) => e.right;
export const prLeft = (e) => e.left;
/**
 * @deprecated since 4.0.3
 * Use `isLeft` or `isRight` from "fp-ts/Either" instead.
 */
export const is = {
    Left: E.isLeft,
    Right: E.isRight,
};
const Eq = E.getEq(Setoid, Setoid);
// Setoid
/**
 * @deprecated since 2.0
 * Use `getEq` from "fp-ts/Either" instead.
 */
export const equals = (e1, e2) => Eq.equals(e1, e2);
// Functor
/**
 * @deprecated since 4.0.3
 * Use `map` from "fp-ts/Either" instead.
 */
export const map = (g, e) => E.map(g)(e);
export const mapmap = (g, e1) => map((e2) => map(g, e2), e1);
// Bifunctor
/**
 * @deprecated since 4.0.3
 * Use `bimap` from "fp-ts/Either" instead.
 */
export const bimap = (g, h, e) => E.bimap(g, h)(e);
/**
 * @deprecated since 4.0.3
 * Use `mapLeft` from "fp-ts/Either" instead.
 */
export const first = (g, e) => bimap(g, id, e);
/**
 * @deprecated since 4.0.3
 * Use `map` from "fp-ts/Either" instead.
 */
export const second = (g, e) => bimap(id, g, e);
/**
 * @deprecated since 4.0.3
 * Use `fold` from "fp-ts/Either" instead.
 */
export const either = (g, h, e) => E.fold(g, h)(e);
/**
 * @deprecated since 4.0.3
 * Use `swap` from "fp-ts/Either" instead.
 */
export const swap = (e) => E.swap(e);
/**
 * @deprecated since 4.0.3
 * Use `getOrElse` from "fp-ts/Either" instead.
 */
export const fromEither = (e, a) => either(() => a, (x) => x, e);
// Apply
/**
 * @deprecated since 4.0.3
 * Use `ap` from "fp-ts/Either" instead.
 */
export const ap = (e1, e2) => {
    if (E.isLeft(e1) &&
        E.isLeft(e2) &&
        Array.isArray(e1.left) &&
        Array.isArray(e2.left)) {
        return left(A.concat(e1.left, e2.left));
    }
    else {
        return E.ap(e2)(e1);
    }
};
// Applicative
/**
 * @deprecated since 4.0.3
 * Use `of` from "fp-ts/Either" instead.
 */
export const of = (a) => right(a);
// Alt
/**
 * @deprecated since 4.0.3
 * Use `alt` from "fp-ts/Either" instead.
 */
export const alt = (e1, e2) => E.alt(() => e2)(e1);
// Chain
/**
 * @deprecated since 4.0.3
 * Use `chain` from "fp-ts/Either" instead.
 */
export const chain = (g, e) => E.chain(g)(e);
// Monad
/**
 * @deprecated since 4.0.3
 * Use `flatten` from "fp-ts/Either" instead.
 */
export const join = (e) => E.flatten(e);
// Foldable
/**
 * @deprecated since 4.0.3
 * Use `reduce` from "fp-ts/Either" instead.
 */
export const reduce = (g, a, e) => E.reduce(a, g)(e);
/**
 * @deprecated since 4.0.3
 * Use `sequence` from "fp-ts/Either" instead.
 */
export const sequenceEither = (e) => E.sequence(E.Applicative)(e);
/**
 * @deprecated since 4.0.3
 * Use `foldMap` from "fp-ts/Either" instead.
 */
export const foldMapConst = (g, b, e) => reduce((_, a) => g(a), b, e);

